<template>
  <Component
    :is="'content-' + component?.type?.replace(/_/g, '-')"
    v-for="(component, index) in components"
    :key="index"
    :data="component"
    :class="{
      'mt-10 sm:mt-12 md:mt-14 lg:mt-16 xl:mt-16':
        component.type === 'images' && index === 0,
      '!pt-0':
        component.type === 'images' && components[index - 1]?.type === 'text',
      '!pb-0':
        component.type === 'images' && components[index + 1]?.type === 'text',
    }"
  />
</template>

<script setup>
defineProps({
  components: { type: Array, default: () => [] },
})
</script>
